import { render, staticRenderFns } from "./vehiclemovement.vue?vue&type=template&id=5c5784a0&scoped=true"
import script from "./vehiclemovement.vue?vue&type=script&lang=js"
export * from "./vehiclemovement.vue?vue&type=script&lang=js"
import style0 from "./vehiclemovement.vue?vue&type=style&index=0&id=5c5784a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5784a0",
  null
  
)

export default component.exports